import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 600px; /* We don't want the footer to jump all the way up during loading content */
  flex: 1;
`;

export const MainContainer = ({ children }: PropsWithChildren) => <Container role="main">{children}</Container>;
